module.exports = __webpack_public_path__ + "img/phase2-2015-02-02.c823de98.jpg";